import { Tabs } from 'antd';
import React from 'react';
import { useSearchParams } from 'react-router';

import MarketingConsentCampaignEligibleContainer from './marketing-consent-campaign-eligible-container';
import MarketingConsentCampaignSentContainer from './marketing-consent-campaign-sent-container';

const TAB_PARAM = 'tab';
const DEFAULT_TAB = 'eligible';

function MarketingConsentCampaignContainer(): React.ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeKey = searchParams.get(TAB_PARAM) ?? DEFAULT_TAB;

  return (
    <Tabs
      activeKey={activeKey}
      destroyOnHidden
      onChange={(key): void => {
        setSearchParams((params) => {
          params.set(TAB_PARAM, key);
          return params;
        });
      }}
      items={[
        {
          key: 'eligible',
          label: 'Eligible Customers',
          children: <MarketingConsentCampaignEligibleContainer />,
        },
        {
          key: 'sent',
          label: 'Sent History',
          children: <MarketingConsentCampaignSentContainer />,
        },
      ]}
    />
  );
}

export default MarketingConsentCampaignContainer;
